import { useRecoilState, useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

import { submitForm as submitFormApi } from 'lib/api';
import { trackEvent } from 'lib/tracking';
import {
  formSubmissionPendingState,
  formSubmissionErrorState,
  showSubmitErrorState,
  submissionResultState,
} from 'state/atoms/submit';

const useSubmitActions = () => {
  const { t } = useTranslation();
  const [pending, setPending] = useRecoilState(formSubmissionPendingState);
  const [error, setError] = useRecoilState(formSubmissionErrorState);
  const [showError, setShowError] = useRecoilState(showSubmitErrorState);
  const setSubmissionResult = useSetRecoilState(submissionResultState);

  const reset = () => {
    setPending(false);
    setError('');
    setSubmissionResult(null);
  };

  const submitForm = (
    formSessionUuid: string,
    formData: any,
    locale?: string
  ) => {
    setError('');
    setPending(true);
    return submitFormApi(formSessionUuid, formData, locale)
      .then((responseData) => {
        trackEvent('request', 'submit', 'success', {
          formType: formData.formType,
        });
        setSubmissionResult(responseData);
        return responseData;
      })
      .catch((errorResponse) => {
        let errorMessage = t<string>('errors.genericSubmit');

        const errorResponseMessage = errorResponse?.response?.data?.error;
        if (errorResponseMessage === 'invalid') {
          errorMessage = 'Invalid Code';
        }
        setError(errorMessage);
        setShowError(true);
        trackEvent('request', 'submit', 'fail', {
          formType: formData.formType,
        });
        throw new Error(errorMessage);
      })
      .finally(() => setPending(false));
  };

  return { error, pending, showError, reset, submitForm };
};

export default useSubmitActions;
